import { Lock } from 'lucide-react';

const LEVEL_IMAGES = {
  beginner: 'https://images.pexels.com/photos/7991579/pexels-photo-7991579.jpeg?auto=compress&cs=tinysrgb&w=800',
  intermediate: 'https://images.pexels.com/photos/66134/pexels-photo-66134.jpeg?auto=compress&cs=tinysrgb&w=800',
  advanced: 'https://images.pexels.com/photos/1181406/pexels-photo-1181406.jpeg?auto=compress&cs=tinysrgb&w=800',
};

const LEVELS = [
  { id: 'beginner', label: 'Beginner', available: true },
  { id: 'intermediate', label: 'Intermediate', available: false },
  { id: 'advanced', label: 'Advanced', available: false },
];

const CourseLevelPicker = ({ courseThumbnail, beginnerPrice, onSelectBeginner }) => (
  <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
    {LEVELS.map((level) => {
      const isLocked = !level.available;
      const imageSrc =
        level.id === 'beginner' && courseThumbnail
          ? courseThumbnail
          : LEVEL_IMAGES[level.id];
      const priceLabel =
        level.id === 'beginner' && beginnerPrice != null && beginnerPrice > 0
          ? `₹${beginnerPrice.toLocaleString('en-IN')}`
          : null;

      const inner = (
        <>
          <img
            src={imageSrc}
            alt={level.label}
            loading="eager"
            className={`absolute inset-0 w-full h-full object-cover transition-transform duration-500 ${
              isLocked ? 'opacity-40 grayscale' : 'opacity-90 group-hover:scale-105'
            }`}
          />
          <div
            className={`absolute inset-0 ${
              isLocked
                ? 'bg-gradient-to-t from-black via-black/80 to-black/50'
                : 'bg-gradient-to-t from-black via-black/50 to-black/20'
            }`}
          />
          <div className="absolute inset-0 flex flex-col items-center justify-center p-6 text-center z-10">
            {isLocked && (
              <div className="mb-3 flex items-center justify-center w-10 h-10 rounded-full border border-white/20 bg-black/60">
                <Lock className="w-4 h-4 text-zinc-300" />
              </div>
            )}
            <h3 className="font-serif text-2xl md:text-3xl text-white mb-2 drop-shadow-lg">{level.label}</h3>
            {isLocked ? (
              <span className="text-xs tracking-[0.2em] uppercase text-zinc-400">Coming soon</span>
            ) : (
              <>
                {priceLabel && (
                  <span className="text-lg font-serif text-white mb-2 drop-shadow-lg">{priceLabel}</span>
                )}
                <span className="text-xs tracking-[0.2em] uppercase text-[#C8102E] font-semibold">View course</span>
              </>
            )}
          </div>
        </>
      );

      if (level.available) {
        return (
          <button
            key={level.id}
            type="button"
            onClick={onSelectBeginner}
            data-testid="course-level-beginner"
            className="group relative w-full min-h-[220px] sm:min-h-[260px] aspect-[4/3] overflow-hidden bg-zinc-900 border border-white/10 hover:border-[#C8102E]/60 transition-colors text-left"
          >
            {inner}
          </button>
        );
      }

      return (
        <div
          key={level.id}
          aria-disabled
          data-testid={`course-level-${level.id}-locked`}
          className="relative w-full min-h-[220px] sm:min-h-[260px] aspect-[4/3] overflow-hidden bg-zinc-900 border border-white/5 cursor-not-allowed"
        >
          {inner}
        </div>
      );
    })}
  </div>
);

export default CourseLevelPicker;
